import { useMutation } from '@tanstack/react-query'

import { TGenericAPIError } from '~/app/models'
import {
  TOfuSimulateContactMessages,
  TOfuSimulatePayloadMessages,
} from '~/features/campaigns/models'
import { EHttpService, EServerPath } from '~/models/api'
import HttpService from '~/services/http'

const simulateOfuCampaignMessages = (payload: TOfuSimulatePayloadMessages) => {
  return HttpService.post<TOfuSimulateContactMessages | TGenericAPIError>(
    {
      path: EServerPath.simulateOfuCampaignMessages,
      payload,
    },
    EHttpService.internal,
  ).then((res) => {
    return res.data ? res.data : res
  })
}

const useOfuSimulateMessages = () => {
  const mutation = useMutation({
    mutationFn: (payload: TOfuSimulatePayloadMessages) =>
      simulateOfuCampaignMessages(payload),
  })

  return {
    ...mutation,
  }
}

export default useOfuSimulateMessages
